import React from 'react';

import { StyledSpinner } from './styles';

interface SpinnerProps {
  size?: 'sm' | 'md';
  /**
   * BB10 — decorativo: quando `true` o spinner sai da árvore de acessibilidade
   * (sem `role="status"` nem `aria-label`). Serve para spinners dentro de um
   * contêiner que já é `role="status"`, evitando duas live regions aninhadas.
   */
  'aria-hidden'?: boolean;
  /** BB10 — permite ao consumidor ajustar só o layout (ex.: `flex-shrink: 0`). */
  className?: string;
}

export function Spinner({
  size = 'md',
  'aria-hidden': ariaHidden,
  className,
}: SpinnerProps) {
  if (ariaHidden) {
    return <StyledSpinner $tamanho={size} className={className} aria-hidden />;
  }
  return (
    <StyledSpinner
      $tamanho={size}
      className={className}
      role="status"
      aria-label="Carregando"
    />
  );
}
